import { injectScript } from './script-loader.service';

export const initializeGA4 = (ga4Id: string): boolean => {
  if (!ga4Id) return false;
  
  try {
    // Injeta o script do GA4
    const ga4Script = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${ga4Id}');
    `;
    
    // Injeta o script do Google Analytics
    const googleAnalyticsScript = `
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    `;
    
    injectScript(googleAnalyticsScript);
    injectScript(ga4Script);
    
    // Configura o GA4 específico
    window.gtag?.('config', ga4Id);
    return true;
  } catch (error) {
    console.error(`❌ GA4 - Erro ao inicializar ${ga4Id}:`, error);
    return false;
  }
}; 